import type { FormValues, NormalizedFormValues, SignFormExperiments } from 'src/app/pages/petitionDetails/shared/types';

import { normalizeCaptcha } from './normalizeCaptcha';
import { normalizeGdprConsent } from './normalizeGdprConsent';
import { normalizePostalCode } from './normalizePostalCode';
import { normalizePublic } from './normalizePublic';
import { normalizeStateCode } from './normalizeStateCode';

export function normalizeSignData(values: FormValues, experiments: SignFormExperiments): NormalizedFormValues {
	const { city, countryCode, firstName, lastName, email, reasonForSigning, phoneNumber, address } = values;
	const incomingCountryCode = address && address.countryCode ? address.countryCode : countryCode;
	const incomingStateCode = address && address.stateCode ? address.stateCode : values.stateCode;
	const incomingPostalCode = address && address.postalCode ? address.postalCode : values.postalCode;

	return {
		firstName,
		lastName,
		email,
		phoneNumber,
		reasonForSigning: reasonForSigning || null,
		shareInfoWithOrganization: false,
		public: normalizePublic(values),
		marketingCommsConsent: normalizeGdprConsent(values, experiments),
		recaptchaResponse: normalizeCaptcha(values),
		address: address ? address.address : '',
		city: address ? address.city : city,
		stateCode: normalizeStateCode({ stateCode: incomingStateCode, countryCode: incomingCountryCode }),
		countryCode: incomingCountryCode,
		postalCode: normalizePostalCode({ postalCode: incomingPostalCode, countryCode: incomingCountryCode }),
	};
}
